Ext.define('SA.model.User', {
    statics: {
        async build() {
            var userData = SA.userData || SA.Ajax.request({resource: 'user'}),
                notices = await SA.Ajax.request({resource: 'notifications/user'}),
                importTerms = new SA.ImportTerms(notices.find(({type}) => type === 'user-data-import-terms')),
                notices = SA.model.Notices.deserialize(notices),
                params = Object.assign({notices, importTerms}, await userData);

            SA.User = new SA.model.User(params);
        },

        getScreenName() {
            var username = SA.User?.getUsername() ?? SA.userData.username;

            return SA.userData.anonymous ? 'Guest' : username;
        }
    },

    constructor(data) {
        this.anonymous = data.anonymous;
        this.canAuthenticateByKey = data.canAuthenticateByKey;
        this.firstSessionOn = data.firstSessionOn;
        this.id = data.id;
        this.username = data.username;
        this.notices = data.notices;
        this.importTerms = data.importTerms;
    },

    didAgreeToImportTerms() {
        return this.importTerms.didAgree();
    },

    getAdHocNotices() {
        return this.getNotices().adHoc;
    },

    getCanAuthenticateByKey() {
        return this.canAuthenticateByKey;
    },

    getEmailAddress() {
        var username = this.getUsername(),
            isEmailAddress = Ext.form.field.VTypes.email(username);

        return isEmailAddress ? username : '';
    },

    getFirstSessionOn() {
        return this.firstSessionOn;
    },

    getId() {
        return this.id;
    },

    getNotices() {
        return this.notices;
    },

    getUsername() {
        return this.username;
    },

    isGuest() {
        return this.anonymous;
    },

    setDidAgreeToImportTerms() {
        this.importTerms.setDidAgree();
    },

    setUsername(username) {
        this.username = username;
    }
});
